import React from 'react'
import Modal from '../../modals/wrapper'
import EditForm from '../edit-form'
import View from '../view'
import BusyModal from '../../modals/busy'
import useUserReflection from './use-user-reflection'

const UserReflectionModal = ({
    onHide = () => {},
    userId,
    promptId,
}) => {
    const { userReflection, isLoadingUserReflection, isEditable } = useUserReflection({ userId, promptId })

    if (isLoadingUserReflection) {
        return (<BusyModal title='Loading Reflection' />)
    }

    const Component = isEditable ? EditForm : View

    return (
        <Modal
            backdrop='static'
            closeButton
            onHide={onHide}
        >
            <Component userId={userId} promptId={promptId} onComplete={onHide} userReflection={userReflection}/>
        </Modal>
    )
}

export default UserReflectionModal